import { RouteConfig } from "vue-router";

const TenantCreateLayout = () => import("./layouts/TenantCreateLayout.vue");
const TenantsCreate = () => import("./pages/TenantsCreate.vue");
const VerifyEmail = () => import("./pages/VerifyEmail.vue");

export const routes: RouteConfig[] = [
  {
    path: "/tenants",
    component: TenantCreateLayout,
    children: [
      {
        path: "new",
        name: "TenantsCreate",
        component: TenantsCreate,
      },
      {
        path: "wait-verification",
        name: "VerifyEmail",
        component: VerifyEmail,
      },
    ],
  },
];
